// TypeScript counterpart of libs/utils/src/constants/LocaleConstants.res

// For OMS
export const en = 'en';
export const bn = 'bn';
export const tr = 'tr';
export const enInd = 'in';

// For NextJs, Strapi
export const en_BD = 'en';
export const bn_BD = 'bn-BD';
export const en_AE = 'en-AE';
export const en_TR = 'en-TR';
export const tr_TR = 'tr-TR';
export const en_TK = 'en-TK'; // Proxy locale for en-TR used in Strapi
export const en_IN = 'en-IN';
export const en_MY = 'en-MY';

export const bdLocales = [en_BD, bn_BD];
export const aeLocales = [en_AE];
export const trLocales = [en_TR, tr_TR];
export const indLocales = [en_IN];
export const myLocales = [en_MY];

export const en_string = 'English';
export const bn_string = 'Bangla';
export const ae_string = 'English';
export const tr_string = 'Turkish';
export const my_string = 'English';

export const uae_default = en_AE;
export const tr_default = tr_TR;
export const bd_default = bn_BD;
export const ind_default = en_IN;
export const my_default = en_MY;
